import { isPublished, isFundraising, isPreparing } from '@src/utils/course';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getTagText = ({ t, status }): string[] => {
	if (isPublished(status)) { // 已開課
		return [t('training:course:online:list:title')];
	}
	if (isFundraising(status)) { // 募資中
		return [t('training:course:online:list:title'), t('training:course:common:status:fundraising')];
	}
	if (isPreparing(status)) { // 募資成功
		return [t('training:course:online:list:title'), t('training:course:common:status:preparing_short')];
	}
	return [t('training:course:online:list:title')];
};

export const makePercentageValue = ({
	isExpired,
	totalBackers,
	goalBackers,
}: {
	isExpired: boolean;
	totalBackers: number;
	goalBackers: number;
}): number => {
	const percentage = Number((totalBackers / goalBackers).toFixed(2)) * 100;
	if (isExpired && percentage < 100) {
		return 100;
	}
	return Math.round(percentage);
};
